import { useState } from "react"

import { Film, Image } from "@/components/icons"
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"

type MediaType = "video" | "image"

export function DemoMediaTypeSelector() {
  const [mediaType, setMediaType] = useState<MediaType>("video")

  return (
    <div className="w-full sm:max-w-xs">
      <Tabs value={mediaType} onValueChange={(value) => setMediaType(value as MediaType)}>
        <TabsList className="bg-muted grid w-full grid-cols-2 rounded-md border-0 p-1">
          <TabsTrigger
            className="data-[state=active]:bg-background flex items-center gap-2 rounded border-0 shadow-none data-[state=active]:border-0 data-[state=active]:shadow-sm"
            value="video"
          >
            <Film className="h-4 w-4" />
            <span>Videos</span>
          </TabsTrigger>
          <TabsTrigger
            className="data-[state=active]:bg-background flex items-center gap-2 rounded border-0 shadow-none data-[state=active]:border-0 data-[state=active]:shadow-sm"
            value="image"
          >
            <Image className="h-4 w-4" />
            <span>Images</span>
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  )
}
